var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5508 52.5273C51.5293 47.2773 45.8555 43.75 39.375 43.75H30.625C24.1445 43.75 18.4707 47.2773 15.4492 52.5273C20.2617 57.8867 27.2344 61.25 35 61.25C42.7656 61.25 49.7383 57.873 54.5508 52.5273ZM0 35C0 25.7174 3.68749 16.815 10.2513 10.2513C16.815 3.68749 25.7174 0 35 0C44.2826 0 53.185 3.68749 59.7487 10.2513C66.3125 16.815 70 25.7174 70 35C70 44.2826 66.3125 53.185 59.7487 59.7487C53.185 66.3125 44.2826 70 35 70C25.7174 70 16.815 66.3125 10.2513 59.7487C3.68749 53.185 0 44.2826 0 35ZM35 37.1875C37.6107 37.1875 40.1145 36.1504 41.9606 34.3043C43.8066 32.4583 44.8438 29.9545 44.8438 27.3438C44.8438 24.733 43.8066 22.2292 41.9606 20.3832C40.1145 18.5371 37.6107 17.5 35 17.5C32.3893 17.5 29.8855 18.5371 28.0394 20.3832C26.1934 22.2292 25.1562 24.733 25.1562 27.3438C25.1562 29.9545 26.1934 32.4583 28.0394 34.3043C29.8855 36.1504 32.3893 37.1875 35 37.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/User Circle.39a0836e3fbc06163d6a803f2ef8750c.svg";
export { ForwardRef as ReactComponent };